export namespace ScreeningPackageConstants {
  export const SCREENING_PACKAGE_MVR_CODE: string = 'MVR';
  export const SCREENING_PACKAGE_CRIMINAL_CODE: string = 'CRIM';
  export const SCREENING_PACKAGE_DRUG_AND_ALCOHOL_CODE: string = 'DXA';
  export const SCREENING_PACKAGE_DRUG_CODE: string = 'DRUG';
  export const SCREENING_PACKAGE_ALCOHOL_CODE: string = 'ALC';
  export const SCREENING_PACKAGE_OIG_LEIE_CODE: string = 'OIG';
  export const SCREENING_PACKAGE_MVR_SUSPENSION_CODE = 'MVRSUS';
}
